<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import FooterWrapper from "@/components/FooterWrapper";

export default {
  // Included components
  components: {
    FooterWrapper,
  },

  data() {
    return {
      // The email address to send the password reset link to
      email: "",
    };
  },

  computed: {
    // Mapped vuex state
    ...mapState(["teams"]),
    ...mapGetters(["authenticated"]),
  },

  // When created, grab the email address from the query string
  created() {
    this.email = this.$route.query.email || "";
  },

  methods: {
    // On submit, reset the password via the API, then go to email sent page
    async submit() {
      let success = await this.resetPassword({ email: this.email });

      if (success) {
        await this.$router.push("/password-reset/email-sent");
      }
    },

    // Mapped vuex actions
    ...mapActions(["resetPassword", "getUser", "getTeams"]),
    ...mapMutations(["setActiveTeamId"]),
  },
};
</script>

<template>
  <FooterWrapper>
    <b-container class="mt-3">
      <b-row align-h="center">
        <b-col lg="9" xl="8">
          <h1>Reset Password</h1>
          <b-card>
            <b-card-text>
              <b-form @submit.stop.prevent="submit">
                <b-form-group id="email-group" label="Email" label-for="email">
                  <b-form-input
                    required
                    id="email"
                    type="email"
                    v-model="email"
                    placeholder="Email"
                  ></b-form-input>
                </b-form-group>

                <b-button type="submit" variant="primary">
                  Reset Password
                </b-button>
              </b-form>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </FooterWrapper>
</template>
